import OliverText from "@builder/components/general/OliverText";
// import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
// import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const SplitPayment = () => {
    const dispatch = useAppDispatch();
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    // const [splitAmount, setSplitAmount] = useState<string>(actionStep?.action?.data.splitAmount || "");
    // const [isPercent, setPercent] = useState<boolean>(actionStep?.action?.data.isPercent || false);

    // const handleAmount = (value: string) => {
    //     if (isPercent) {
    //         if (/^\d*$/.test(value) && Number(value) >= 0 && Number(value) <= 100) {
    //             setSplitAmount(value);
    //         }
    //     } else {
    //         if (/^\d*\.?\d{0,2}$/.test(value)) {
    //             setSplitAmount(value);
    //         }
    //     }
    // };

    // const handleToggle = () => {
    //     setPercent(prev => !prev);
    //     setSplitAmount("");
    // };

    useEffect(() => {
        const action = { type: ActionType.SPLIT_PAYMENT, data: { isFixed } };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText
                text="Manually enter a payment less than the full balance due"
                size="xs"
                weight="medium-heavy"
                translatePrefix="popup.actionBuilder."
            />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText
                            text="Show keypad to enter amount"
                            size="xs"
                            weight="medium-heavy"
                            translatePrefix="popup.actionBuilder."
                        />
                        <OliverText
                            text="This will open the partial payment pop-up"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    {/* <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} /> */}
                </div>
                {/* <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText
                            text="Split by a fixed pre-set amount"
                            size="xs"
                            weight="medium-heavy"
                            translatePrefix="popup.actionBuilder."
                        />
                        <OliverText
                            text="This will split the amount by a fixed amount"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div> */}
                {/* {isFixed ? (
                    <TextInput
                        callback={handleAmount}
                        value={splitAmount}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle();
                            }
                        }}
                        isPercent={isPercent}
                    />
                ) : null} */}
            </div>
        </div>
    );
};

export default SplitPayment;
